import Aura from '@primeng/themes/aura';
import { SIDEBAR_ITEMS } from '../app/core/constants/sidebar';
import { Environment } from 'libs/core/src/public-api';
export const environment: Environment = {
  apiUrl: 'https://api.ratel-incidenti.dev.itcentar.rs/api/admin',
  loadingToastDelay: 500,
  dateFormat: 'dd. MM. yyyy HH:mm',
  dateLocale: 'sr-Latn-RS',
  theme: {
    color: 'zinc',
    preset: Aura,
  },
  SUPPORTED_LANGUAGES: ['en', 'sr', 'cyr'],
  sidebarItems: SIDEBAR_ITEMS,
  UI: {
    MOBILE_BREAKPOINT: 768,
  },
  DEV_ONLY_REMOVE_FOR_PROD: {
    ALLOW_FIELD_REMOVAL: true,
    ALLOW_FIELD_ADDING: true,
    ALLOW_DEFAULT_FIELD_MODIFICATION: true,
  },
  STORAGE: {
    user: 'cmsUser',
    token: 'cmsToken',
    tokenExpirationDate: 'cmsTokenExpirationDate',
    language: 'cmsLanguage',
    theme: 'cmsTheme',
  },
  APP_TYPE: 'cms',
  OTP_EXPIRATION_SECONDS: 1800,
  OTP_LENGTH: 6,
  HAS_RECAPTCHA: true,
  RECAPTCHA_SITE_KEY: '6LfJRm4rAAAAAGkliOjCF5A90AUV46osE6V8OPuJ',
};
